module.exports = __webpack_public_path__ + "media/images/products/about/pencil-6af95681f964956979dd243c69abc4be.png";